// DOM content loaded event listener
document.addEventListener("DOMContentLoaded", function () {
  const productSpecifications = document.querySelectorAll(
    ".product-specifications",
  );

  const specificationWrapper = document.querySelector(".specification-wrapper");

  productSpecifications.forEach((spec) => {
    const title = spec.querySelectorAll(".product-specifications--title");

    if (title[0]) {
      title[0].addEventListener("click", function () {
        title[0].classList.toggle("active");
        specificationWrapper.classList.toggle("active");
        var panel = title[0].nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  });

  Fancybox.bind("[data-prodgallerybox]", {
    zoomEffect: true,
  });

  let swiperNavigation = new Swiper(".product-section--gallery-bottom", {
    loop: true,
    slidesPerView: 5,
    spaceBetween: 11,
    // centeredSlides: true,
  });

  if (window.innerWidth <= 991) {
    let swiperMain = new Swiper(".product-section--gallery-top", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 4,
      centeredSlides: true,

      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swipper-buttons-wrapper .swiper-button-next",
        prevEl: ".swipper-buttons-wrapper .swiper-button-prev",
      },
      on: {
        init: function () {
          updateCounter(this);
        },
        slideChange: function () {
          updateCounter(this);
        },
      },
    });
  } else {
    let swiperMain = new Swiper(".product-section--gallery-top", {
      loop: true,
      slidesPerView: 10,
      // allowTouchMove: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      thumbs: {
        swiper: swiperNavigation,
      },
      navigation: {
        nextEl: ".product-section--gallery-bottom-wrapper .swiper-button-next",
        prevEl: ".product-section--gallery-bottom-wrapper .swiper-button-prev",
      },
    });
  }

  function updateCounter(swiper) {
    const total = swiper.slides.length;
    const current = swiper.realIndex + 1;

    document.querySelector(
      ".swiper-pagination-counter-product .current",
    ).textContent = format(current);
    document.querySelector(
      ".swiper-pagination-counter-product .total",
    ).textContent = format(total);
  }

  function format(num) {
    return num < 10 ? "0" + num : num;
  }
});
